export const muiModalStyles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgColor: "background.paper",
  border: "2px solid #000",
  borderRadius: 4,
  backgroundColor: "#f1f1f1",
  boxShadow: 24,
  display: "flex",
  flexDirection: "column",
  p: 2,
};
